
    import QuestionMixin from '@/components/JobView/Apply/Questions/QuestionMixin';

    export default {
        name: 'QuestionSelect',

        mixins: [
            QuestionMixin,
        ],

        data() {
            return {
                answer: {},
                questionId: `question_select_${this.question.id}`,
            };
        },

        computed: {
            validationRules() {
                return this.question.is_mandatory ? `${this.question.validation_rules}|object:id` : '';
            },
        },

        watch: {
            answer() {
                this.$emit('answer', {
                    question: this.question,
                    answer: this.answer.id,
                });
            },
        },

        created() {
            this.getObjectAnswer();
        },

        methods: {},
    };
